/**
 * cookie 操作
 */

const cookie = {
  get(name) {
    let end = '';
    const dc = document.cookie;
    const prefix = `${name}=`;
    let begin = dc.indexOf(`; ${prefix}`);
    if (begin === -1) {
      begin = dc.indexOf(prefix);
      if (begin !== 0) return null;
    } else {
      begin += 2;
      end = document.cookie.indexOf(';', begin);
      if (end === -1) {
        end = dc.length;
      }
    }
    return decodeURI(dc.substring(begin + prefix.length, end));
  },
  set(key, value, path) {
    const Days = 30;
    const exp = new Date();
    exp.setTime(exp.getTime() + Days * 24 * 60 * 60 * 1000);
    if (path) {
      document.cookie = `${key}=${escape(value)};expires=${exp.toGMTString()};path=${path}`;
    } else {
      document.cookie = `${key}=${escape(value)};expires=${exp.toGMTString()}`;
    }
  },
  remove(key) {
    document.cookie = `${key}=; expires=Thu, 01 Jan 1970 00:00:01 GMT;`;
  },
};

export default cookie;
